<template>
  <div v-on:contextmenu.prevent>
    <v-menu offset-y offset-overflow>
      <template v-slot:activator="{ on: { click, keydown }, value, attrs }">
        <v-card
          tile outlined
          class="timeline-title-container v-btn d-flex justify-start px-2"
          v-bind="attrs"
          v-bind:height="timelineHeightPx"
          v-on:keydown="$_onKeydown(value, keydown, click, $event)"
          v-on:click.left="click"
      >
          <v-icon>mdi-plus</v-icon>
        </v-card>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(menuContent, menuContentIdx) in menuContents"
          v-bind:key="menuContentIdx"
          v-bind:disabled="menuContent.disabled"
          v-on:click.left="menuContent.callback"
        >
          <v-list-item-title>{{ menuContent.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped>
.timeline-title-container {
  background-color: #f3f3f3;
}
</style>

<script>
export default {
  props: {
    timelineHeightPx: { type: Number },
    menuContents:     { type: Array },
  },

  methods: {
    $_onKeydown(isMenuOpen, onKeydownCallback, onClickCallback, event) {
      if (isMenuOpen) {
        onKeydownCallback(event);
      } else {
        switch (event.code) {
        case 'Enter':
        case 'Space':
          onClickCallback(event);
          break;
        }
      }
    },
  },
};
</script>
